import {alcanza, type AreaDeAcceso, type NivelDeAcceso, type SesionActual, type UsuarioActual} from '@cnc/contracts';
import {createContext, useContext} from 'react';
import {tr} from '../i18n/idioma';

// La sesion abierta, disponible en toda la aplicacion una vez que la persona entro.
export const ContextoDeSesion = createContext<SesionActual | null>(null);

// Seccion o pestana de la pantalla que se esta viendo (decision 0062). Con
// ella, "editar" de usePermisos dice si la persona edita ahi.
export const ContextoDeArea = createContext<AreaDeAcceso[] | null>(null);

export function useSesion(): SesionActual {
  const sesion = useContext(ContextoDeSesion);
  if (!sesion) throw new Error(tr('No hay sesión abierta.', 'There is no open session.'));
  return sesion;
}

export const useUsuario = (): UsuarioActual => useSesion().usuario;

// Nivel de la persona en una seccion o pestana: no, ver o editar.
export const nivelDe = (usuario: UsuarioActual, clave: string): NivelDeAcceso => usuario.accesos[clave] ?? 'no';
export const useNivel = (clave: string): NivelDeAcceso => nivelDe(useUsuario(), clave);
export const useVe = (clave: string) => alcanza(useNivel(clave), 'ver');

// Lo que el rol de la persona le deja hacer, y dentro de una seccion o
// pestana lo que el administrador le dejo; la API lo vuelve a comprobar.
export const usePermisos = () => {
  const usuario = useUsuario();
  const areas = useContext(ContextoDeArea);
  if (!areas) return usuario.permisos;
  return {...usuario.permisos, editar: usuario.permisos.editar && areas.some(a => nivelDe(usuario, a) === 'editar')};
};
